/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alternative_OptionsInputs */

const en_alternative_options = /** @type {(inputs: Alternative_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternative Options`)
};

const es_alternative_options = /** @type {(inputs: Alternative_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones alternativas`)
};

const fr_alternative_options = /** @type {(inputs: Alternative_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options alternatives`)
};

const de_alternative_options = /** @type {(inputs: Alternative_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternative Optionen`)
};

const ja_alternative_options = /** @type {(inputs: Alternative_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代替オプション`)
};

const zh_alternative_options = /** @type {(inputs: Alternative_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他选项`)
};

const ar_alternative_options = /** @type {(inputs: Alternative_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خيارات بديلة`)
};

const id_alternative_options = /** @type {(inputs: Alternative_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opsi Alternatif`)
};

const it_alternative_options = /** @type {(inputs: Alternative_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni Alternative`)
};

const ru_alternative_options = /** @type {(inputs: Alternative_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Альтернативные варианты`)
};

const pt_alternative_options = /** @type {(inputs: Alternative_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções Alternativas`)
};

const ko_alternative_options = /** @type {(inputs: Alternative_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대체 옵션`)
};

/**
* | output |
* | --- |
* | "Alternative Options" |
*
* @param {Alternative_OptionsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const alternative_options = /** @type {((inputs?: Alternative_OptionsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alternative_OptionsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_alternative_options(inputs)
	if (locale === "es") return es_alternative_options(inputs)
	if (locale === "fr") return fr_alternative_options(inputs)
	if (locale === "de") return de_alternative_options(inputs)
	if (locale === "ja") return ja_alternative_options(inputs)
	if (locale === "zh") return zh_alternative_options(inputs)
	if (locale === "ar") return ar_alternative_options(inputs)
	if (locale === "id") return id_alternative_options(inputs)
	if (locale === "it") return it_alternative_options(inputs)
	if (locale === "ru") return ru_alternative_options(inputs)
	if (locale === "pt") return pt_alternative_options(inputs)
	return ko_alternative_options(inputs)
});